import React, { useState } from "react";
import { toast } from "sonner";
import { Lock, User, Loader2 } from "lucide-react";
import { adminLogin, apiError } from "../../lib/adminApi";
import { useAdminAuth } from "../../context/AdminAuth";
import TargetLogo from "../../components/TargetLogo";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await adminLogin(username.trim(), password);
      login(data.token, data.username);
      toast.success("Welcome back, Admin!");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0c1622] px-4">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm rounded-2xl bg-white p-7 shadow-2xl"
      >
        <div className="mb-5 flex flex-col items-center text-center">
          <TargetLogo size={54} />
          <h1 className="mt-3 text-xl font-extrabold text-[#10161f]">
            Admin Login
          </h1>
          <p className="text-sm text-slate-500">Bhutan Morning Teer</p>
        </div>

        <label className="mb-1 block text-sm font-semibold text-slate-700">
          Username
        </label>
        <div className="relative mb-4">
          <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="admin-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            className="w-full rounded-lg border border-slate-300 py-2.5 pl-9 pr-3 text-sm outline-none focus:border-[#1ab5a3]"
            placeholder="admin"
          />
        </div>

        <label className="mb-1 block text-sm font-semibold text-slate-700">
          Password
        </label>
        <div className="relative mb-5">
          <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            className="w-full rounded-lg border border-slate-300 py-2.5 pl-9 pr-3 text-sm outline-none focus:border-[#1ab5a3]"
            placeholder="••••••••"
          />
        </div>

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#1ab5a3] py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#0f9b8a] disabled:opacity-60"
        >
          {loading && <Loader2 size={16} className="animate-spin" />}
          Login
        </button>
      </form>
    </div>
  );
}
